<template>
    <section v-if="products.length > 0"
        class="product-list my-container my-margin-bottom-30 m-5">
        <h2 class="section-title"><span>{{ title }}</span></h2>
        <most-popular-products
            :products="products"
            :type="type"
        ></most-popular-products>
    </section>
</template>

<script>
export default {
    name: 'RelatedProducts',

    props: {
        product: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            products: []
        }
    },

    mounted() {
        this.fetchProducts()
    },

    watch: {
        product() {
            this.fetchProducts()
        }
    },

    methods: {
        async fetchProducts() {
            try {
                const response = await axios.get(this.url, {
                    params: {
                        productId: this.product.id,
                        type: this.type
                    }
                })
                this.products = response.data
            } catch (error) {
                console.error(error)
            }
        },
    }
}
</script>

<style scoped>

</style>
